import { jsx as _jsx } from "react/jsx-runtime";
// TODO: Update based on requirements on it should parse and share data
import { IconButton } from '@material-ui/core';
import { ChatOutlined } from '@material-ui/icons';
export function CellMessage() {
    return (_jsx(IconButton, { "data-testid": 'data-grid-row-message', disableFocusRipple: true, disableRipple: true, disableTouchRipple: true, children: _jsx(ChatOutlined, { color: 'primary' }) }));
}
